import React from "react";
import { useApp } from "@/hooks";

export const HoverIcon = ({ className }: { className: string }): JSX.Element => {
  return (
    <div className={`w-6 h-6 ${className}`}></div>
  );
};

export const ToggleHover = ({ item, onClick }: any) => {
  const { screen } = useApp();

  if (screen === "" || screen === "sm") {
    return (
      <div
        className="max-w-[322px] h-[42px] md:max-w-[490px] md:h-[48px] flex justify-between items-center border border-[#9197A2] rounded-[44px] px-[9px] md:px-[14px] toggle-container"
        onTouchEnd={onClick}
      >
        <span className="ml-1 text-[14px] font-500 md:text-[16px] md:leading-[27px] font-400 font-inter">
          {item.toggleText}
        </span>
        <div className="plus-icon">
          <img
            src="/images/home/plus-default.svg"
            alt="Plus Icon"
            className="w-6 h-6 md:w-6 md:h-6"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="max-w-[322px] h-[42px] md:max-w-[490px] md:h-[48px] flex justify-between items-center border border-[#9197A2] rounded-[44px] px-[9px] md:px-[14px] toggle-container"
      onClick={onClick}
    >
      <span className="ml-1 text-[14px] font-500 md:text-[16px] md:leading-[27px] font-400 font-inter">
        {item.toggleText}
      </span>
      <div className="plus-icon">
        <img
          src="/images/home/plus-default.svg"
          alt="Plus Icon"
          className="w-6 h-6 md:w-6 md:h-6"
        />
      </div>
    </div>
  );
};
